import angular from 'angular';

import RwMultistoreSelectorDialogComponent from './rw-multistore-selector-dialog-component';

export default angular
  .module('rw-multistore-selector-dialog', [
    'rw-button',
    'rw-subordinates-table',
  ])
  .component('rwMultistoreSelectorDialog', new RwMultistoreSelectorDialogComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-multistore-selector/components/rw-multistore-selector-dialog/rw-multistore-selector-dialog-module.js